/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import Select from 'react-select';
import request from '../../utils/APIHelper/request';
import { controllers, requestTypes } from '../../constants/enums/API';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import Table from '../../components/Table/Table';
import classNames from 'classnames';
import loadingGif from '../../assets/Other/loading.gif';
import {
  branchNames,
  branchNamesCaliforniaIncluded,
} from '../../constants/enums/RefundContacts';
import ReactPaginate from 'react-paginate';
import AddAgentByEmailModal from '../../components/AddingAgent/AddAgentByEmail';
import UpdateAgentInList from '../../components/UpdatingAgent/UpdatingAgentWindow';
import { currentUser } from '../../utils/Auth/auth';

const AgentsMap = ({ swalModal }) => {
  const branchOptions = [
    {
      value: '1',
      label: '1 - Canada',
      isDisabled:
        !currentUser.branches.includes('1') &&
        !currentUser.baseBranch.includes('1'),
    },
    {
      value: '2',
      label: '2 - New Jersey',
      isDisabled:
        !currentUser.branches.includes('2') &&
        !currentUser.baseBranch.includes('2'),
    },
    {
      value: '3',
      label: '3 - California',
      isDisabled:
        !currentUser.branches.includes('3') &&
        !currentUser.baseBranch.includes('3'),
    },
    {
      value: '4',
      label: '4 - Chicago',
      isDisabled:
        !currentUser.branches.includes('4') &&
        !currentUser.baseBranch.includes('4'),
    },
  ];
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = queryString.parse(search);

  const [editButtonLoading, setEditButtonLoading] = useState();
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState();
  const [agentList, setAgentList] = useState();
  const [agent, setAgent] = useState();
  const [agentName, setAgentName] = useState(params.agentName);
  const [email, setEmail] = useState(params.email);
  const [address, setAddress] = useState(params.address);
  const [agentsForSearch, setAgentsForSearch] = useState();
  const [pageAmount, setPageAmount] = useState();
  const [totalItemsCount, setTotalItemsCount] = useState();

  const changeBranch = async (selectedBranch, onPageLoad = false) => {
    if (selectedBranch) {
      setBranch(selectedBranch);
      const result = await request({
        url: `${controllers.agent}GetAgentsOnMapByBranch`,
        type: requestTypes.post,
        params: { branchId: selectedBranch.value },
      });
      const agents = result?.map((a) => ({ value: a, label: a }));
      setAgentsForSearch(agents);
    } else {
      setAgentsForSearch([]);
    }
    if (!onPageLoad) setAgent(null);
    setBranch(selectedBranch);
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await request({
        url: `${controllers.agent}getAgentListPage`,
        type: requestTypes.post,
        body: {
          page: params.page,
          branchId: params.branch,
          agentCode: params.agent,
          agentName: params.agentName,
          email,
          address,
        },
        setLoading,
      });
      setAgentList(result?.agentList);
      setPageAmount(result?.pages);
      setTotalItemsCount(result?.total);
    };
    fetchData();
  }, [search]);

  useEffect(() => {
    changeBranch(
      branchOptions.find((option) => option.value === params.branch),
      true,
    );
    setAgent(
      params.agent ? { value: params.agent, label: params.agent } : null,
    );
  }, []);

  const getQueryParamsByPage = (pageNum) => {
    return {
      ...(branch && { branch: branch?.value }),
      ...(agent && { agent: agent?.value }),
      ...(agentName && { agentName }),
      ...(email && { email }),
      ...(address && { address }),
      ...{ page: pageNum },
    };
  };

  const addAgentModal = (type) => {
    swalModal.fire({
      title: 'Add new agent',
      html: <AddAgentByEmailModal addingType={type} />,
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-auto text-sm',
      },
    });
  };

  const editAgent = async (id) => {
    setEditButtonLoading(id);
    const result = await request({
      url: `${controllers.agent}getAgentById`,
      type: requestTypes.post,
      params: { id },
    });
    setEditButtonLoading(null);
    if (!result?.agent) return;
    console.log(result);
    swalModal.fire({
      title: `Update the agent ${result.agent.agentCode || '---'}`,
      html: (
        <UpdateAgentInList
          defaultAgentData={result.agent}
          extensionData={result.ext}
        />
      ),
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-auto text-sm',
      },
    });
  };

  const agentsTableDisplayView = (agents = []) => {
    return agents.map((a) => ({
      'Agent Code': a?.agentCode,
      Branch: {
        element: branchNamesCaliforniaIncluded[a?.branchId] || '---',
      },
      'Agent name': a?.agentName || '---',
      'Contact name': a?.contactName || '---',
      'Full address': a?.address || '---',
      Phones: a?.phone || '---',
      Email: a?.email || '---',
      Status:
        a?.status === 'A' ? (
          <span className="text-green-600">Active</span>
        ) : (
          <span className="text-red-600">Inactive</span>
        ),
      'View or edit': (
        <div className="text-center">
          {editButtonLoading === a?.id ? (
            <img src={loadingGif} className="w-4 h-4 mx-auto" />
          ) : (
            <span
              onClick={() => editAgent(a?.id)}
              className={classNames(
                'rounded-xl bg-blue-800 text-white px-2 cursor-pointer hover:bg-blue-900 hover:transition-all hover:duration-300',
              )}
            >
              DETAILS
            </span>
          )}
        </div>
      ),
    }));
  };

  return (
    <div className="mb-40">
      <div className="w-full text-left my-5 px-10">
        <div className="my-2 my-5 text-blue-900 text-lg">Search by</div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Branch:</div>
          <Select
            value={branch}
            onChange={(selected) => changeBranch(selected)}
            options={branchOptions}
            className="min-w-0 flex-grow text-left text-blue-800"
            placeholder="Choose branch..."
            isClearable={true}
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Agent:</div>
          <div
            data-tooltip-id="my-tooltip"
            data-tooltip-content={
              !branch ? 'Need to select branch first' : null
            }
          >
            <Select
              isDisabled={!branch}
              value={agent}
              onChange={(selected) => setAgent(selected)}
              options={agentsForSearch}
              className="min-w-0 flex-grow text-left text-blue-800"
              placeholder="Choose agent..."
              isClearable={true}
            />
          </div>
          <Tooltip id="my-tooltip" />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Agent name:</div>
          <input
            value={agentName}
            onChange={(e) => setAgentName(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Agent name..."
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">Email:</div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Email..."
          />
        </div>
        <div className="inline-block mx-3">
          <div className="text-blue-900 my-1">
            {'Address/City/ZIP (partial match):'}
          </div>
          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="text-blue-900 border-b border-blue-900 focus:outline-none focus:border-blue-300 px-2"
            placeholder="Address/City/ZIP..."
          />
        </div>
      </div>
      <Link
        to={`/agentList?${queryString.stringify(getQueryParamsByPage(1))}`}
        className={classNames(
          'text-white text-lg bg-blue-900 w-auto inline-block py-1 px-5 rounded-full hover:bg-blue-800 hover:transition-all hover:duration-30 cursor-pointer my-10',
          loading && '!bg-gray-400 cursor-auto',
        )}
      >
        {'Search'}
      </Link>

      {!loading ? (
        <>
          <div>
            <ReactPaginate
              onPageChange={(e) => {
                const redirectPage = Number.parseInt(e.selected) + 1;
                navigate(
                  `/agentList?${queryString.stringify(getQueryParamsByPage(redirectPage))}`,
                );
              }}
              forcePage={Number.parseInt(params.page) - 1 || 0}
              pageCount={pageAmount}
              pageRangeDisplayed={4}
              marginPagesDisplayed={2}
              containerClassName={classNames(
                'flex flex-row w-1/2 float-left my-0 text-sm xl:text-sm',
              )}
              activeLinkClassName="!text-blue-400 !border-blue-400"
              pageLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
              previousLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
              nextLinkClassName="mx-3 text-blue-700 border-[1px] border-blue-700 rounded-xl min-w-[20px] px-[5px] xl:px-2 py-[1px] xl:py-[1px] hover:text-blue-400 hover:border-blue-400 hover:duration-300"
            />
          </div>
          <br />
          <div className="text-left p-4 text-blue-800">
            Total: {totalItemsCount}
          </div>

          <div className="text-left text-blue-900 p-4 bg-none mt-5">
            Add new agent
            <div
              data-tooltip-id="agent-adding-tooltip"
              className="cursor-pointer bg-blue-900 text-white rounded-full h-6 w-6 inline-flex items-center justify-center pb-[2px] mx-2 hover:bg-blue-800 hover:transition-all hover:duration-300"
            >
              +
            </div>
            <Tooltip
              clickable
              delayHide={400}
              id="agent-adding-tooltip"
              style={{
                backgroundColor: 'white',
                boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)',
                borderRadius: '15px',
              }}
              place="top"
            >
              <div
                onClick={() => addAgentModal('email')}
                className="inline-block bg-blue-900 text-white px-3 cursor-pointer mx-2 rounded-full hover:bg-blue-800 hover:transition-all hover:duration-30"
              >
                Add by email of existing account
              </div>
              <div
                onClick={addAgentModal}
                className="inline-block bg-blue-900 text-white px-3 cursor-pointer mx-2 rounded-full hover:bg-blue-800 hover:transition-all hover:duration-30"
              >
                Add manually
              </div>
            </Tooltip>
          </div>
          <Table
            rowsClassName="text-[0.68vw] font-semibold xl:font-normal xl:text-[0.6rem] 2xl:text-xs"
            headersClassNames="text-[0.68vw] md:font-semibold font-bold xl:text-[0.6rem] 2xl:text-xs"
            data={agentsTableDisplayView(agentList)}
          />
        </>
      ) : (
        <img className="w-5 h-5 mx-auto" src={loadingGif} />
      )}
    </div>
  );
};

export default AgentsMap;
